import type { ReactNode } from "react";
import { Group, Stack, Text, Title } from "@mantine/core";

export interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  /** Right-aligned actions (buttons, etc.). */
  actions?: ReactNode;
}

/**
 * The standard page title block — composed from Mantine `Group`/`Title`/`Text`.
 * Feature screens render one at the top of their content.
 */
export function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    // wrap (2026-07-29): on phones the actions drop below the title instead
    // of squeezing it — on desktop everything still fits one line.
    <Group justify="space-between" align="flex-start" wrap="wrap" mb="lg">
      <Stack gap={4}>
        <Title order={1} fz="h2">
          {title}
        </Title>
        {description && (
          <Text c="dimmed" fz="sm">
            {description}
          </Text>
        )}
      </Stack>
      {actions && <div>{actions}</div>}
    </Group>
  );
}
